document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".pre-access-btn");
  const wrapper = document.querySelector(".custom-form-klaviyo");

  if (btn && wrapper) {
    btn.addEventListener("click", function () {
      wrapper.style.display = wrapper.style.display === "flex" ? "none" : "flex";
    });

  }
});

document.addEventListener("DOMContentLoaded", function () {

    const overlay = document.getElementById('overlay');

    if (!overlay) {
    console.error("Overlay not found");
    return;
    }

    // move drawers to body
    document.querySelectorAll('.drawer').forEach(drawer => {
    document.body.appendChild(drawer);
    });

    document.body.appendChild(overlay);

    // OPEN
    document.querySelectorAll('.size_guide').forEach(btn => {
    btn.addEventListener('click', () => {

        const id = btn.getAttribute('data-popup');
        const drawer = document.getElementById('drawer-' + id);

        if (!drawer) return;

        drawer.classList.add('active');
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
    });
    });

    // CLOSE
    function closeAll() {
    document.querySelectorAll('.drawer').forEach(d => d.classList.remove('active'));
    overlay.classList.remove('active');
    document.body.style.overflow = '';
    }

    document.querySelectorAll('.close-btn').forEach(btn => {
    btn.addEventListener('click', closeAll);
    });

    overlay.addEventListener('click', closeAll);

    document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
    });

});



(function () {
  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    return originalFetch.apply(this, args).then((response) => {

      const url = args[0];

      // detect add to cart
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('Product page add detected');

        setTimeout(() => {
          loadUpsells(); // 👈 refresh upsell
        }, 300);
      }

      return response;
    });
  };
})();